import type Policy from 'models/Policy';
import { policyStates } from 'models/Policy';

export type GLArchetype =
  | 'active_gl'
  | 'cancelled_gl'
  | 'expired_gl'
  | 'no_prior_gl';

const GL_PRODUCT_NAME = 'general liability';

const hasGLProduct = (productDisplayNames: string[]): boolean =>
  productDisplayNames.some(name => name.toLowerCase() === GL_PRODUCT_NAME);

const hasGLPolicyWithState = (policies: Policy[], states: string[]): boolean =>
  policies.some(
    policy => hasGLProduct(policy.productDisplayNames)
      && states.includes(policy.state),
  );

/**
 * Returns the GL archetype for a customer based on their policies.
 *
 * Priority:
 * 1. active_gl - has active, pending, or cancellation_scheduled GL
 * 2. cancelled_gl - has cancelled GL (no active)
 * 3. expired_gl - has expired GL (no active, no cancelled)
 * 4. no_prior_gl - no GL policies at all
 */
export const getGLArchetype = (policies: Policy[]): GLArchetype => {
  if (hasGLPolicyWithState(policies, [
    policyStates.active,
    policyStates.pending,
    policyStates.cancellationScheduled,
  ])) {
    return 'active_gl';
  }

  if (hasGLPolicyWithState(policies, [policyStates.cancelled])) {
    return 'cancelled_gl';
  }

  if (hasGLPolicyWithState(policies, [policyStates.expired])) {
    return 'expired_gl';
  }

  return 'no_prior_gl';
};
